import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";
import _ from "lodash";
import Nodes from "csi/store/Nodes";
import { C8Node } from "csi/typings";
import { DEP_PATH } from "csi/constants";
import { FIELD_DOCUMENT_TEMPLATE, FIELD_OUTPUT_TYPE, EXCEL_FILE_EXTENSION } from "./DGaaSSelectTemplate";
import { getGeneratedDocumentType } from "csi/model/document";
import enums from "csi/enums";
const DGaaSRegenerateTemplate = declare(Widget, {

	/**
	 * @override
	 * Query for DGaaSTemplate and DGaaSTemplateRevisions
	 */
	onViewStart(dfds: dojo.store.api.QueryResults<C8Node>[]): void {
		const { cacheView } = this;
		const store = new Nodes({
			cachingStore: cacheView,
			typeNode: "DGaaSTemplate",
			requestParameters: {
				[DEP_PATH]: "Child:CurrentRevision;LatestRevision",
			},
		});
		dfds.push(store.query());

		//Disable the field if the document is initially generated using an Excel template.
		const docMaster = this.cacheView.getNode(this.urlRoot);
		const currentRevision = docMaster ? this.cacheView.getNode(docMaster.CurrentRevision) : null;
		if (currentRevision) {
			const dGaaSTemplateRevision = this.cacheView.getNode(currentRevision.DGaaSTemplateRevision);
			if (dGaaSTemplateRevision && dGaaSTemplateRevision.Id) {
				const fileId = dGaaSTemplateRevision.Id;
				if (fileId.includes(EXCEL_FILE_EXTENSION)) {
					this.setFieldDisabled(FIELD_OUTPUT_TYPE, true);
				}
			}
		}
		this.inherited(arguments);
	},

	/**
	 *  @override
	 * Modified the form view
	 * Make UseLatestRevisionOfTemplate default value true
	 * Disable the field DocumentTemplate so no one can change
	 * Add default value OutputType enum dropdown based on existing file extension
	 */
	_resolveView: function () {
		this.inherited(arguments);
		this.addDefaultValue("UseLatestRevisionOfTemplate", true);
		this.setFieldDisabled(FIELD_DOCUMENT_TEMPLATE, true);

		const docMaster = this.cacheView.getNode(this.urlRoot);
		const currentRevision = this.cacheView.getNode(docMaster.CurrentRevision);

		const enumname = getGeneratedDocumentType(currentRevision);
		this.addDefaultValue(FIELD_OUTPUT_TYPE, enumname);
	},

	/**
	 * @override
	 * Don't add empty entry
	 */
	getFieldStore(field, value) {
		if (field.m_name == FIELD_OUTPUT_TYPE) {
			return enums.getStore("DGaaSGeneratedDocumentType", value, null, true);
		}
		return this.inherited(arguments);
	},

});
export default DGaaSRegenerateTemplate;
